module.exports = __webpack_public_path__ + "static/media/roboto-regular-webfont.5206c894.woff";